// src/components/avisEnseignants/useCompteurAvisNouveaux.js
// Le nombre d'avis d'enseignants encore « nouveaux », pour la pastille de
// l'onglet « Avis des enseignants » de la page Vie scolaire.
//
// Lu une fois à l'ouverture de la page, sans attendre qu'on clique l'onglet :
// la pastille sert justement à dire qu'il y a quelque chose à lire. L'onglet,
// une fois ouvert, tient ensuite le compte à jour par `mettreAJour` (chaque
// lecture de sa liste renvoie les compteurs) ; dès lors, la première lecture,
// si elle revenait après lui, ne remet pas à l'écran un compte dépassé.
//
// Un échec reste muet : la pastille disparaît, l'onglet dira lui-même ce qui
// ne va pas quand on l'ouvrira. Une page Vie scolaire ne doit pas afficher une
// erreur pour un module (l'espace enseignant) qu'on n'est pas venu consulter.

import { useCallback, useEffect, useRef, useState } from 'react';
import { avisEnseignants } from './apiAvisEnseignants';

export default function useCompteurAvisNouveaux(actif) {
  const [nombre, setNombre] = useState(null);
  const tenuParOnglet = useRef(false);

  const mettreAJour = useCallback((valeur) => {
    tenuParOnglet.current = true;
    const n = Number(valeur);
    setNombre(Number.isFinite(n) ? n : null);
  }, []);

  useEffect(() => {
    if (!actif) {
      setNombre(null);
      return undefined;
    }
    let abandonne = false;
    avisEnseignants.liste({ statut: 'nouveau' })
      .then((reponse) => {
        if (abandonne || tenuParOnglet.current) return;
        const valeur = Number(reponse?.data?.compteurs?.nouveau);
        setNombre(Number.isFinite(valeur) ? valeur : null);
      })
      .catch(() => {
        if (!abandonne && !tenuParOnglet.current) setNombre(null);
      });
    return () => { abandonne = true; };
  }, [actif]);

  return [nombre, mettreAJour];
}
